<script setup lang="ts">
import type { ISuitable } from '@/pages/forLaywers/model/types/suitableSection';

const isMobile: boolean = useIsMobile();

const suitables: ISuitable[] = [
  {
    id: 1,
    mode: '_first',
    iconName: 'Person',
    text: 'Юристы и адвокаты',
  },
  {
    id: 2,
    mode: '_second',
    iconName: 'Person2',
    text: 'Юридические компании',
  },
  {
    id: 3,
    mode: '_third',
    iconName: 'Person3',
    text: 'Адвокатские конторы',
  },
];
</script>

<template>
  <section :class="['suitable', { _mobile: isMobile }]" data-testid="suitable-section">
    <div class="suitable__inner">
      <h2 class="suitable__title" data-testid="suitable-title">Для кого подходит?</h2>
      <ul class="suitable__list">
        <li
          v-for="suitable of suitables"
          :key="suitable.id"
          :class="['suitable__list-item', suitable.mode]"
          data-testid="suitable-list-item"
        >
          <AppIcon class="suitable__list-icon" :name="suitable.iconName" />
          <div class="suitable__text">
            {{ suitable.text }}
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<style lang="less">
.suitable {
  background: @color-elephant;
  padding-top: 317px;
  padding-bottom: 213px;

  &__inner {
    .container-d();
  }

  &__title {
    .title-section();

    color: #fff;
    text-align: center;
    margin-bottom: 50px;
  }

  &__list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1032px;
    margin: 0 auto;
  }

  &__list-item {
    text-align: center;

    &._first {
      max-width: 137px;
    }

    &._second {
      max-width: 171px;
    }

    &._third {
      max-width: 162px;
    }
  }

  &__list-icon {
    max-width: @size-x10;

    path {
      stroke: @color-persimmon;
    }
  }

  &__text {
    font-size: @size-x6;
    line-height: @size-x7;
    font-weight: 400;
    color: #fff;
    margin-top: 10px;

    @media @1280 {
      font-size: @size-x5;
      line-height: @size-x6;
    }
  }

  &._mobile {
    padding-top: @size-x9;
    padding-bottom: 75px;
  }

  &._mobile &__inner {
    .container-m();
  }

  &._mobile &__title {
    font-size: @size-x6;
    line-height: 25px;
    margin-bottom: @size-x6;
  }

  &._mobile &__list {
    flex-direction: column;
  }

  &._mobile &__list-item:not(:last-child) {
    margin-bottom: @size-x10;
  }

  &._mobile &__text {
    font-size: @size-x4;
    line-height: 22px;
  }
}
</style>
